import axios from 'axios'
import { useQuery } from 'react-query'
import { destroyAlert, errorAlert, loadingAlert } from '../../utils/alert'

// BrasilAPI e Minha Receita usam a mesma base (dados abertos da Receita) e devolvem o mesmo formato
interface TypeCnpj {
  cnpj: string
  razao_social: string
  nome_fantasia: string
  descricao_situacao_cadastral: string
  cep: string
  descricao_tipo_de_logradouro: string
  logradouro: string
  numero: string
  complemento: string
  bairro: string
  municipio: string
  uf: string
  ddd_telefone_1: string
  email: string | null
}

const useGetCnpjSecundario = (cnpj: string, triggerError?: Function) => {
  const queryKey: any = [`dadosCnpjSecundario${cnpj}`]

  const { data, isFetching, refetch, isFetchedAfterMount } = useQuery<TypeCnpj, Error>(
    queryKey,
    async () => {
      return axios
        .get(`https://minhareceita.org/${cnpj}`)
        .then((response): any => {
          triggerError?.(false)
          destroyAlert();
          return response.data
        })
        .catch(() => {
          destroyAlert()
          setTimeout(() => {
            errorAlert('Falha ao buscar CNPJ!', 5000)
          }, 500)
          triggerError?.(true)
        })
    },
    {
      enabled: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_cnpj: data ?? undefined,
    carregando: isFetching,
    refetchSecundario: refetch,
    isFetched: isFetchedAfterMount,
  }
}

export const useGetCnpj = (cnpj: string, triggerError?: Function) => {
  const queryKey: any = [`dadosCnpj${cnpj}`]
  const { refetchSecundario } = useGetCnpjSecundario(cnpj)
  const { data, isFetching, refetch, isFetchedAfterMount } = useQuery<TypeCnpj, Error>(
    queryKey,
    async () => {
      return axios
        .get(`https://brasilapi.com.br/api/cnpj/v1/${cnpj}`)
        .then((response): any => {
          triggerError?.(false)
          destroyAlert('cnpj')
          return response.data
        })
        .catch(() => {
          triggerError?.(true)
          destroyAlert('cnpj');
          // Desembrulha o resultado do refetch para a reserva chegar no mesmo formato da principal
          return refetchSecundario().then((resultado) => resultado.data)
        })
    },
    {
      enabled: false,
      retry: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_cnpj: data ?? undefined,
    carregando: isFetching,
    refetch: refetch,
    isFetched: isFetchedAfterMount,
  }
}

export const useGetCep = (cep: string, triggerError?: Function) => {
  const queryKey: any = [`dadosCep${cep}`]
  const { data, isFetching, refetch, isFetchedAfterMount } = useQuery<TypeCep, Error>(
    queryKey,
    async () => {
      return axios
        .get(`https://viacep.com.br/ws/${cep}/json/`)
        .then((response): any => {
          triggerError?.(false)
          destroyAlert('cep')
          return response.data
        })
        .catch(() => {
          triggerError?.(true)
          destroyAlert('cep')
        })
    },
    {
      enabled: false,
      retry: false,
      refetchOnWindowFocus: false,
    }
  )

  return {
    data_cep: data ?? undefined,
    carregando: isFetching,
    refetch_cep: refetch,
    isFetched: isFetchedAfterMount,
  }
}
